import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BranchingQueryDefinition, getChildEdgeTypeId, Group } from '@iotv/datamodel-core';
import { AdjacentType, ComparisonType, getZombieInstanceFromPrimaryKey, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { Autocomplete, Button, TextField, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 } from 'uuid';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import AppDao from '../../data/AppDao';
import { getGraphQueryRequestV2 } from '../../data/daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
import { LoadingAnimationModal } from '../../Popup/Loading';
import { NavSections } from '../navigation/NavSections';
import { DeviceLinkContext } from './DeviceLinkContext';
import DisplayEntityDetail from './DisplayEntityDetail';
// import { getCustomerEntitys, getPropertyEntitys } from './Support/LinkingQueries'
const getPropertyGroup = (entity) => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Property' }],
        subQueries: [],
    });
    const propertyToGroupQuery = new BranchingQueryDefinition({
        id: 'propertyToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: getChildEdgeTypeId('Property', 'Group'), // 'group_has_area', //
                nodeFilters: [
                    {
                        filters: [
                            {
                                key: 'supportedType',
                                predicate: ComparisonType.EQUALS,
                                value: entity,
                            },
                        ],
                        setOperation: LogicalOperatorType.AND,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(propertyToGroupQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
const getGroupEntity = (entity) => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Group' }],
        subQueries: [],
    });
    const groupToEntityQuery = new BranchingQueryDefinition({
        id: 'groupToEntityQuery',
        path: [
            {
                objectTypeId: entity,
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: undefined, //getChildEdgeTypeId('Property', 'Group'), // 'group_has_area', //
            },
        ],
        subQueries: [],
    });
    const entityToDeviceQuery = new BranchingQueryDefinition({
        id: 'entityToDeviceQuery',
        path: [
            {
                objectTypeId: 'Device',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: undefined, //getChildEdgeTypeId('Property', 'Group'), // 'group_has_area', //
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(groupToEntityQuery);
    groupToEntityQuery.addSubQuery(entityToDeviceQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
const LinkingEntity = (props) => {
    const { setEntityList, setChoosenEntity, setPrelinkedDevice, setUnlinkDevice } = props;
    const [{ contextCustomer, contextProperty }] = useContext(AppMainViewContext);
    const { selectedEntityType, device, allowEntities, choosenEntity, entityList, prelinkedDevice } = useContext(DeviceLinkContext);
    const navigate = useNavigate();
    const [mapper, setMapper] = useState();
    const [message, setMessage] = useState('');
    const [entityGroups, setEntityGroups] = useState();
    const [selectedEntityGroup, setSelectedEntityGroup] = useState();
    const createNewEntity = (entityName) => {
        if (entityGroups) {
            if (!selectedEntityGroup) {
                setMessage('Checking For Default Group');
                const defaultName = `Default ${entityName} Group`;
                const defaultGroup = entityGroups.find((grp) => grp.name === defaultName);
                if (defaultGroup) {
                    navigate(`/${NavSections.ADMIN_VIEW}/Group/${defaultGroup.id}`);
                }
                else {
                    setMessage('No Group Found. Creating Default Group');
                    const newGroup = new Group({
                        ...getZombieInstanceFromPrimaryKey(`Group:${v4()}`),
                        name: defaultName,
                        supportedType: entityName,
                    });
                    AppDao.save(newGroup).then((savingRes) => {
                        const savedObjectRes = savingRes.data;
                        if (savedObjectRes) {
                            AppDao.link(contextProperty ?? contextCustomer, savedObjectRes, getChildEdgeTypeId(contextProperty?.type ?? 'Customer', savedObjectRes.type)).then((res1) => {
                                const link = `/${NavSections.ADMIN_VIEW}/Group/${savedObjectRes.id}`;
                                navigate(link);
                            });
                        }
                    });
                }
            }
            else {
                navigate(`/${NavSections.ADMIN_VIEW}/Group/${selectedEntityGroup.id}`);
            }
        }
        else {
            navigate(`/${NavSections.ADMIN_VIEW}/Group?supportedType=${entityName}`);
        }
    };
    useEffect(() => {
        if (selectedEntityType && contextProperty) {
            getGraphQueryRequestV2({
                contextObjects: [contextProperty],
                query: getPropertyGroup(selectedEntityType.name).query,
            }).then((res) => {
                if (res.data) {
                    const entityFound = res.data.getNodesOfType('Group');
                    setEntityGroups(entityFound);
                }
                else {
                    setEntityGroups([]);
                }
            });
        }
        else {
            setEntityGroups([]);
        }
    }, [selectedEntityType, contextCustomer, contextProperty]);
    useEffect(() => {
        if (selectedEntityGroup && selectedEntityType) {
            const type = selectedEntityType.name;
            getGraphQueryRequestV2({
                contextObjects: [selectedEntityGroup],
                query: getGroupEntity(type).query,
            }).then((e) => {
                if (e.data) {
                    const entityFound = e.data.getNodesOfType(type);
                    setMapper(e.data);
                    setEntityList(entityFound);
                    setChoosenEntity && setChoosenEntity(undefined);
                }
                else {
                    setEntityList([]);
                    setChoosenEntity && setChoosenEntity(undefined);
                }
            });
        }
        else if (selectedEntityType === undefined) {
            setChoosenEntity && setChoosenEntity(undefined);
            setEntityList([]);
        }
    }, [selectedEntityGroup, selectedEntityType]);
    useEffect(() => {
        if (choosenEntity && mapper) {
            const child = mapper.getChildNodes(choosenEntity).filter((val) => val.type === 'Device');
            setPrelinkedDevice && setPrelinkedDevice(child);
            if (child.length === 1) {
                setUnlinkDevice && setUnlinkDevice(child[0]);
            }
        }
        else {
            setPrelinkedDevice && setPrelinkedDevice(undefined);
            setUnlinkDevice && setUnlinkDevice(undefined);
        }
    }, [choosenEntity, mapper, setPrelinkedDevice]);
    return (_jsxs("div", { children: [_jsxs(Grid, { id: 'View-Relevant-Entities', container: true, size: { xs: 12 }, 
                // spacing={2}
                sx: {
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }, children: [_jsx(Grid, { size: { xs: 4 }, children: _jsx(Typography, { variant: "body2", component: "p", color: "primary", children: `5) ${selectedEntityType?.name ?? 'Entity'} Group` }) }), _jsx(Grid, { size: { xs: 8 }, sx: { flexGrow: 1, pb: 2 }, children: entityGroups && (_jsx(Autocomplete, { options: entityGroups, getOptionLabel: (option) => option.name, renderInput: (params) => _jsx(TextField, { ...params, size: "small", placeholder: `Specific ${selectedEntityType?.name ?? 'Entity'} Group` }), onChange: (_, value) => {
                                setSelectedEntityGroup(value ?? undefined);
                                setChoosenEntity(undefined);
                            }, value: selectedEntityGroup ?? null, disabled: allowEntities === undefined || !allowEntities || device === undefined, isOptionEqualToValue: (opt, val) => opt.id === val.id })) }), _jsx(Grid, { size: { xs: 4 }, children: _jsx(Typography, { variant: "body2", component: "p", color: "primary", children: `6) ${selectedEntityType?.name ?? 'Entity'}` }) }), _jsx(Grid, { size: { xs: 8 }, sx: { flexGrow: 1, pb: 2 }, children: setChoosenEntity && (_jsx(Autocomplete, { options: entityList, getOptionLabel: (option) => option.name, renderInput: (params) => _jsx(TextField, { ...params, size: "small", placeholder: selectedEntityType?.name || 'Specific Entity' }), onChange: (_, value) => setChoosenEntity(value ?? undefined), value: choosenEntity ?? null, disabled: selectedEntityGroup === undefined || !allowEntities || entityList.length === 0 || device === undefined, isOptionEqualToValue: (opt, val) => opt.id === val.id })) })] }), !choosenEntity && (_jsxs(Button, { disabled: selectedEntityType === undefined || selectedEntityType.name === undefined || !allowEntities, onClick: () => selectedEntityType?.name && createNewEntity(selectedEntityType.name), fullWidth: true, variant: "contained", children: ["Create New ", selectedEntityType?.name || 'Entity'] })), choosenEntity && (_jsx(Grid, { id: 'View-Entity-Detail', container: true, size: { xs: 12 }, spacing: 2, sx: {
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }, children: _jsx(DisplayEntityDetail, { entity: choosenEntity, device: prelinkedDevice }) })), message !== '' && _jsx(LoadingAnimationModal, { message: message, background: true })] }));
};
export default LinkingEntity;
